import { UI, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { useOrderHistoryStateActions } from '../../../../../store/orderHistory/actions';

export interface OrderHistoryPeriodSelectorProps {
  isMobile?: boolean;
}

export const OrderHistoryPeriodSelector: React.FC<OrderHistoryPeriodSelectorProps> = ({
  isMobile,
}) => {
  const { setSelectedDateFilterOption, options, selectedOption, availableFilter } =
    useOrderHistoryStateActions();

  const getSelectedLabel = () => {
    if (!availableFilter) {
      return 'Selecione o período';
    }
    const isSection = availableFilter.type === 'section';
    const hasFilterAndIsArray = selectedOption && Array.isArray(selectedOption?.filter);
    if (!isSection || !hasFilterAndIsArray) {
      return 'Selecione o período';
    }
    const foundOption = availableFilter.options.find(
      (option) => option.value === selectedOption?.filter?.[0]
    );

    return foundOption ? foundOption.label : 'Selecione o período';
  };

  return (
    <HStack space={Spacing['inline.nano']} {...(isMobile && { justifyContent: 'space-between' })}>
      <HStack space={Spacing['inline.nano']}>
        <UI.Icon name="Calendar" size="xxxs" color={Color['neutral.medium']} />
        <UI.Text color="neutral.medium">Selecione o período:</UI.Text>
      </HStack>
      <UI.ActionDropdown triggerLabel={getSelectedLabel()} triggerLabelColor="neutral.black">
        {options.map((option) => (
          <UI.ActionDropdown.Item
            key={option.label}
            onPress={() => setSelectedDateFilterOption(option)}
            label={option.label}
            preventFocus
            isActive={selectedOption?.filter?.[0] === option.value}
          />
        ))}
      </UI.ActionDropdown>
    </HStack>
  );
};
